// EINE Regel für alle clientseitigen Freitextsuchen. Rein und vitest-getestet.
// Hintergrund: Rohe Substring-Vergleiche scheitern an Satzzeichen — „eon" fand
// „E.ON Energie" nicht (Bug 2026-08-13).

/** Vergleichsform eines Textes: klein, Umlaute ausgeschrieben, ohne Diakritika
 *  und ohne jedes Satz-/Trennzeichen. So findet „eon" auch „E.ON" und
 *  „391 26 1598" auch „391/26/1598". */
export function vergleichsform(text: string): string {
  return text
    .toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

/** Freitextsuche über mehrere Felder: beide Seiten normalisiert (siehe
 *  vergleichsform). Mehrere Wörter müssen alle treffen, dürfen sich aber auf
 *  verschiedene Felder verteilen. Leerer Begriff passt immer. */
export function trifftText(felder: (string | null | undefined)[], begriff: string): boolean {
  const q = begriff.trim();
  if (!q) return true;

  const normFelder = felder.map((f) => vergleichsform(f || '')).filter(Boolean);

  const ganz = vergleichsform(q);
  if (ganz && normFelder.some((f) => f.includes(ganz))) return true;

  const woerter = q.split(/\s+/).map(vergleichsform).filter(Boolean);
  return woerter.length > 1 && woerter.every((w) => normFelder.some((f) => f.includes(w)));
}
